import baseLogo from '../../assets/images/logo-DEA.png';
import deLogo from '../../assets/images/logo-de.png';

const Footer = {
  title: 'Footer',
  rightLogo: {
    image: deLogo,
    altText: 'Discovery Education Logo'
  },
  leftLogo: {
    image: baseLogo,
    altText: 'base Card Logo'
  }
};

export default Footer;



//////////////////
// WEBPACK FOOTER
// ../shared/src/components/Footer/index.js
// module id = 495
// module chunks = 0